module.exports = __webpack_public_path__ + "static/img/Background.9a9e2d5f.png";